var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5c6.263 0 9.77 6.833 9.937 7.167.084.166.084.5 0 .666-.167.334-3.674 7.167-9.937 7.167-5.895 0-9.349-6.054-9.873-6.974l-.064-.11c-.084-.25-.084-.5 0-.75C.23 9.334 3.737 2.5 10 2.5zM1.733 10c.835 1.333 3.758 5.833 8.267 5.833 4.51 0 7.432-4.5 8.267-5.833C17.432 8.667 14.51 4.167 10 4.167c-4.51 0-7.516 4.5-8.267 5.833zM10 6.667c-1.837 0-3.34 1.5-3.34 3.333A3.347 3.347 0 0 0 10 13.333c1.837 0 3.34-1.5 3.34-3.333A3.347 3.347 0 0 0 10 6.667zM8.33 10c0 .917.751 1.667 1.67 1.667.919 0 1.67-.75 1.67-1.667S10.92 8.333 10 8.333c-.919 0-1.67.75-1.67 1.667z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a8s2dq3esa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5c6.263 0 9.77 6.833 9.937 7.167.084.166.084.5 0 .666-.167.334-3.674 7.167-9.937 7.167-5.895 0-9.349-6.054-9.873-6.974l-.064-.11c-.084-.25-.084-.5 0-.75C.23 9.334 3.737 2.5 10 2.5zM1.733 10c.835 1.333 3.758 5.833 8.267 5.833 4.51 0 7.432-4.5 8.267-5.833C17.432 8.667 14.51 4.167 10 4.167c-4.51 0-7.516 4.5-8.267 5.833zM10 6.667c-1.837 0-3.34 1.5-3.34 3.333A3.347 3.347 0 0 0 10 13.333c1.837 0 3.34-1.5 3.34-3.333A3.347 3.347 0 0 0 10 6.667zM8.33 10c0 .917.751 1.667 1.67 1.667.919 0 1.67-.75 1.67-1.667S10.92 8.333 10 8.333c-.919 0-1.67.75-1.67 1.667z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/social-icon.383cefdbc06a4f54765138a3d467b18d.svg";
export { ForwardRef as ReactComponent };